/*
 *   File : add-field.js
 *   Author : https://evoqins.com
 *   Description :Delete confirm modal
 *   Integrations : js-cookie
 *   Version : 1.0.0
*/

import React, { memo, useEffect, useState } from 'react';
import { toast } from 'react-toastify';

// Custom components
import { PrimaryButton, SecondaryButton } from '../Buttons';
import { CustomTextInput, CustomTextArea } from '../FormElements';
import { APIService } from '../../Service';
import { useFieldInputConfig } from './field-input-config';


const AddFieldModal = ({ handleClose, onSuccess }) => {

    const [createStatus, setCreateStatus] = useState(false);
    const [name, setName] = useState("");
    const [nameError, setNameError] = useState("");
    const [description, setDescription] = useState("");
    const [descriptionError, setDescriptionError] = useState("");
    const [fieldNumber, setFieldNumber] = useState("");
    const [fieldNumberError, setFieldNumberError] = useState("");
    const [paramFormat, setParamFormat] = useState("");
    const [paramFormatError, setParamFormatError] = useState("");
    const [loading, setLoading] = useState(false);
    const [apiError, setApiError] = useState("");

    const {
        componentType,
        buildComponentConfig,
        validateComponentConfig,
        InputConfigFields
    } = useFieldInputConfig();

    useEffect(() => {
        var edit_modal = document.getElementById("add-field-modal");
        edit_modal.addEventListener("hidden.bs.modal", () => {
            setCreateStatus(false);
        });
    }, []);

    // handle close Modal 
    const _handleCloseModal = () => {
        var button = document.getElementById("add-field-modal-close");
        button.click();
        setCreateStatus(false);
        handleClose();
    };

    useEffect(() => {
        setNameError("");
    }, [name]);

    useEffect(() => {
        setDescriptionError("");
    }, [description]);

    useEffect(() => {
        setFieldNumberError("");
    }, [fieldNumber]);

    useEffect(() => {
        setParamFormatError("");
    }, [paramFormat]);

    useEffect(() => {
        setApiError("");
    }, [componentType, name, description, fieldNumber, paramFormat]);

    const _validateField = () => {
        let is_valid = true;
        if (name.trim().length === 0) {
            setNameError("Field name is required");
            is_valid = false;
        }
        if (!validateComponentConfig()) {
            is_valid = false;
        }
        if (is_valid === true) {
            _handleAddField();
        }
    };

    const _handleAddField = () => {
        setLoading(true);
        setApiError("");
        let is_post = true;
        let url = 'field-master/upsert';
        let data = {
            "name": name,
            data_field_number: String(fieldNumber ?? "").trim() === "" ? null : fieldNumber,
            "description": description,
            "param_format": paramFormat,
            component: componentType,
            component_config: buildComponentConfig()
        };

        APIService(is_post, url, data).then((response) => {
            if (response?.status_code === 200) {
                toast.dismiss();
                toast.success(response.res_message || response.message, {
                    type: "success",
                    className: "e-toast",
                });
                onSuccess?.();
                _handleCloseModal();
            } else {
                const errorMessage = response?.message || response?.res_message || "Unable to create field";
                if (response?.status_code === 400) {
                    setApiError(errorMessage);
                } else {
                    toast.dismiss();
                    toast.error(errorMessage, {
                        type: "error",
                        className: "e-toast",
                    });
                    setApiError(errorMessage);
                }
            }
            setLoading(false);
        }).catch(() => {
            setApiError("Unable to create field");
            setLoading(false);
        });
    };


    return (
        <div className="modal fade" id="add-field-modal" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex="-1" aria-labelledby="confirmDeleteModalLabel" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content e-border-radius-28 w-500px mx-auto ">
                    <img src={require("../../Assets/Images/Home/close.svg").default}
                        draggable={false}
                        className='d-none'
                        id='add-field-modal-close'
                        alt='close'
                        data-bs-dismiss="modal" />
                    <div className="modal-header px-4 pt-4 pb-3 border-0 align-items-start justify-content-space-between">


                        <h4 className='mb-0 e-primary-font e-text-raisin-black e-font-16 e-font-weight-600 line-height-28px'>
                            Add Field
                        </h4>
                        <img src={require("../../Assets/Images/Home/close.svg").default}
                            draggable={false}
                            alt='close'
                            className='cursor-pointer'
                            onClick={_handleCloseModal} />
                        {!createStatus &&

                            <img src={require("../../Assets/Images/Home/close.svg").default}
                                draggable={false}
                                className='d-none'
                                id='add-field-modal-close'
                                alt='close'
                                data-bs-dismiss="modal"
                                onPress={_handleCloseModal} />
                        }

                    </div>
                    <div className="modal-body px-4 pb-2 pt-0">

                        <>
                            <CustomTextInput label="Field name"
                                placeholder="Enter field name"
                                type="text"
                                require
                                value={name}
                                error={nameError}
                                autoFocus={true}
                                className="w-100"
                                labelStyle="e-font-weight-400"
                                handleChange={(e) => setName(e)} />

                            <CustomTextInput label="Additional data field number"
                                placeholder="Enter additional data field number"
                                type="number"
                                value={fieldNumber}
                                error={fieldNumberError}
                                className="w-100"
                                labelStyle="e-font-weight-400"
                                handleChange={(e) => setFieldNumber(e)} />

                            <CustomTextInput label="Format"
                                placeholder="Enter param format"
                                type="text"
                                value={paramFormat}
                                error={paramFormatError}
                                className="w-100"
                                labelStyle="e-font-weight-400"
                                handleChange={(e) => setParamFormat(e)} />

                            <CustomTextArea label="Additional data description"
                                placeholder="Enter additional data description"
                                type="text"
                                value={description}
                                error={descriptionError}
                                className="w-100"
                                rows={1}
                                labelStyle="e-font-weight-400"
                                heightClassName="h-64px"
                                handleChange={(e) => setDescription(e)} />

                            {InputConfigFields}

                            {apiError &&
                                <p className="mb-3 e-error-message e-primary-font e-font-12 line-height-18px">
                                    {apiError}
                                </p>
                            }

                            <div className='row row-cols-2 pt-2 mt-2 pb-3'>
                                <div className='col'>
                                    <SecondaryButton name="Cancel"
                                        className="w-100"
                                        onPress={_handleCloseModal} />
                                </div>
                                <div className='col'>
                                    <PrimaryButton name="Create"
                                        className="w-100 e-bg-primary-blue"
                                        status={loading}
                                        onPress={_validateField}
                                    />
                                </div>
                            </div>
                        </>
                    </div>
                </div>
            </div>
        </div>

    )
}

AddFieldModal.defaultProps = {
    handleClose: () => { }
}


export default memo(AddFieldModal);